<template>
  <div style="max-width: 665px; margin: auto">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { FieldHtmlNameUtil, Trans } from '@onshape/www-inertia';
import type UnifiedSignupSessionInfo from './Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type AbstractStartSignupScreen from './Form/coordinator/UnifiedSignup/screens/AbstractStartSignupScreen';
import hekateBus from '~/hekate-www/bus';

const props = defineProps<{
  signupScreen: AbstractStartSignupScreen;
  sessionInfo: UnifiedSignupSessionInfo;
}>();

onMounted(() => {
  const formVariantField = props.signupScreen.getField('formVariant');

  // AB TESTING
  if (formVariantField.val === 'UssAbTest') {
    props.signupScreen.trackEvent('uss-ab-test');
    const email = props.signupScreen.getField(FieldHtmlNameUtil.email);
    email.label = Trans.byValue('Business Email');
  }

  hekateBus.dispatchEvent('lazy-load-images', {});
});
</script>
